import { SearchUsersRequest, UserDto } from '@api/client';
import { useAppDispatch } from 'core/store/hooks';
import { getUsers } from 'pages/private/project-list/project-detail/_redux/actions';
import { useEffect, useState } from 'react';

const useGetAllUsers = () => {
  const dispatch = useAppDispatch();
  const [allUsers, setAllUsers] = useState<UserDto[] | null>(null);

  useEffect(() => {
    if (!allUsers) {
      const request: SearchUsersRequest = {
        userSearchRequest: {
          attivo: false,
        },
      };
      dispatch(getUsers(request))
        .unwrap()
        .then((res) => {
          if (res && res.utenti?.length) {
            setAllUsers(res.utenti);
          }
        });
    }
  }, []);

  return allUsers;
};

export default useGetAllUsers;
